import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VOverlay,{attrs:{"value":_vm.dialogLoading}},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":"64"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }